import { render, staticRenderFns } from "./addFadan.vue?vue&type=template&id=08ebd3c0&scoped=true&"
import script from "./addFadan.vue?vue&type=script&lang=js&"
export * from "./addFadan.vue?vue&type=script&lang=js&"
import style0 from "./addFadan.vue?vue&type=style&index=0&id=08ebd3c0&prod&scoped=true&lang=scss&"
import style1 from "./addFadan.vue?vue&type=style&index=1&id=08ebd3c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebd3c0",
  null
  
)

export default component.exports